export default {
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',

  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',

  'menu.device': 'Devices',
  'menu.device.deviceList': 'Device List',

  'menu.event': 'Event Logs',
  'menu.event.deviceList': 'Device Events',
  'menu.event.commandList': 'Command Events',
  'menu.event.ssfLog': 'SSF Push Log',

  'menu.business': 'Business',
  'menu.business.businessInfo': 'Business Info',
  'menu.business.businessInfo.baseInfo': 'Basic Info',
  'menu.business.businessInfo.requestCertificate': 'Request Certificate',
  'menu.business.businessInfo.enrollmentSettings': 'Enrollment Settings',
  'menu.business.certificate': 'Certificates',
  'menu.business.certificate.operation': 'Operations',
  'menu.business.certificate.discussion': 'Discussion',
  'menu.business.managedAppleId': 'Managed Apple ID',

  'menu.other': 'Other',
  'menu.other.otherMedia': 'Media Files',
  'menu.other.otherAsset': 'Assets',

  'menu.account': 'Account',
  'menu.account.settings': 'Security Settings',
  'menu.account.logout': 'Logout',

  'menu.systemSettings': 'Settings',
  'menu.systemSettings.center': 'User Management',
  'menu.systemSettings.s3Storage': 'S3 Storage',
  'menu.systemSettings.smtp': 'SMTP',
  'menu.systemSettings.platformBackup': 'Platform Backup',
  'menu.systemSettings.oidcApp': 'OIDC Apps',
};
